import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useLinkReferral from '../../hooks/update-hooks/link-referral/link-referral';
import GetRefereeStatus from '../../hooks/fetch-hooks/get-referee-status/get-referee-status';

export default function LinkReferral({ refereeId }) {
    const [open, setOpen] = useState(false);
    const [referralCode, setReferralCode] = useState('');

    const { mutate, isLoading } = useLinkReferral(refereeId);
    const { data: statusData, isLoading: isStatusLoading } = GetRefereeStatus(refereeId);

    const status = statusData?.data?.data || {};
    const hasReferrer = status.hasReferrer === true;

    const close = () => {
        setOpen(false);
        setReferralCode('');
    };

    const handleSubmit = () => {
        const code = referralCode.trim();
        if (!code) {
            return;
        }
        mutate(
            { referralCode: code },
            { onSuccess: (res) => { if (res?.data?.success !== false) close(); } }
        );
    };

    return (
        <div className="mt-4">
            <button
                type="button"
                onClick={() => setOpen(true)}
                disabled={isStatusLoading || hasReferrer}
                className="rounded-md border border-[#168c7c] px-4 py-2 font-sans font-semibold text-[#168c7c] hover:bg-[#168c7c] hover:text-white-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-[#168c7c]"
            >
                Link Referrer
            </button>

            {hasReferrer && (
                <p className="mt-2 font-sans text-sm text-gray-500">
                    Already referred by{status.referrerName ? ` ${status.referrerName}` : ' another user'} — a user can only have one referrer.
                </p>
            )}

            {open && !hasReferrer && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                    <div className="w-[420px] rounded-lg bg-white-50 p-6 shadow-xl">
                        <h3 className="mb-1 font-sans text-lg font-bold text-[#168c7c]">Link Referrer</h3>
                        <p className="mb-4 font-sans text-sm text-gray-500">
                            Enter the referrer&apos;s referral code. This creates the referral record and credits the referee, exactly like a normal signup.
                        </p>

                        <label className="mb-1 block font-sans text-sm font-semibold text-gray-700">Referrer&apos;s referral code</label>
                        <input
                            type="text"
                            value={referralCode}
                            onChange={(e) => setReferralCode(e.target.value)}
                            placeholder="e.g. A2MYA15"
                            className="mb-4 w-full rounded-md border border-gray-300 px-3 py-2 font-sans uppercase focus:border-[#168c7c] focus:outline-none"
                        />

                        <div className="flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={close}
                                disabled={isLoading}
                                className="rounded-md border border-gray-300 px-4 py-2 font-sans font-semibold text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleSubmit}
                                disabled={isLoading || !referralCode.trim()}
                                className="rounded-md bg-[#168c7c] px-4 py-2 font-sans font-semibold text-white-50 hover:bg-[#12796b] disabled:opacity-50"
                            >
                                {isLoading ? 'Linking...' : 'Link'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

LinkReferral.propTypes = {
    refereeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
